// Web stub for expo-image-picker.
// On web, LibraryContext guards cover-art picking behind a Platform.OS check,
// so these implementations are never actually called — they just need to exist
// so webpack doesn't crash when it tries to resolve the module.

export const MediaTypeOptions = { Images: 'Images', All: 'All', Videos: 'Videos' };

export async function requestMediaLibraryPermissionsAsync() {
  return { status: 'granted', granted: true, canAskAgain: true, expires: 'never' };
}

export async function requestCameraPermissionsAsync() {
  return { status: 'granted', granted: true, canAskAgain: true, expires: 'never' };
}

export async function launchImageLibraryAsync() {
  return { canceled: true, assets: [] };
}

export async function launchCameraAsync() {
  return { canceled: true, assets: [] };
}

export function useMediaLibraryPermissions() {
  return [{ status: 'granted', granted: true }, async () => ({ status: 'granted', granted: true })];
}

export function useCameraPermissions() {
  return [{ status: 'granted', granted: true }, async () => ({ status: 'granted', granted: true })];
}

export default {
  MediaTypeOptions,
  requestMediaLibraryPermissionsAsync,
  requestCameraPermissionsAsync,
  launchImageLibraryAsync,
  launchCameraAsync,
  useMediaLibraryPermissions,
  useCameraPermissions,
};
